import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TASK_FEATURE_KEY, State, TaskAdapter } from './tasks.reducer';

export const selectState = createFeatureSelector<State>(TASK_FEATURE_KEY);

const { selectAll, selectEntities } = TaskAdapter.getSelectors();

export const selectLoading = createSelector(
  selectState,
  (state: State) => state.loading
);

export const selectError = createSelector(
  selectState,
  (state: State) => state.error
);
export const selectUpdatedAt = createSelector(
  selectState,
  (state: State) => state.updatedAt
);
export const selectCreateTask = createSelector(
  selectState,
  (state: State) => state.createTask
);

export const selectTasks = createSelector(selectState, (state: State) =>
  selectAll(state)
);

export const selectTasksEntities = createSelector(selectState, (state: State) =>
  selectEntities(state)
);
export const selectActiveTask = createSelector(
  selectState,
  (state: State) => state.activeTask
);

export const selectFilters = createSelector(
  selectState,
  (state: State) => state.filters
);

export const selectHasMore = createSelector(
  selectState,
  (state: State) => state.hasMore
);
